export const ReserveAccountAbi = [
  {
    type: "function",
    name: "admin",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "currencyToken",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "execute",
    inputs: [
      { name: "target", type: "address", internalType: "address" },
      { name: "data", type: "bytes", internalType: "bytes" },
    ],
    outputs: [{ name: "", type: "bytes", internalType: "bytes" }],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "loanRouter",
    inputs: [],
    outputs: [{ name: "", type: "address", internalType: "address" }],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "repay",
    inputs: [
      {
        name: "loanTerms",
        type: "tuple",
        internalType: "struct ILoanRouterV2.LoanTermsV2",
        components: [
          {
            name: "expiration",
            type: "uint64",
            internalType: "uint64",
          },
          {
            name: "borrower",
            type: "address",
            internalType: "address",
          },
          {
            name: "currencyToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "collateralToken",
            type: "address",
            internalType: "address",
          },
          {
            name: "repaymentSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.RepaymentSpec",
            components: [
              {
                name: "totalDurationDays",
                type: "uint16",
                internalType: "uint16",
              },
              { name: "day", type: "uint8", internalType: "uint8" },
              {
                name: "timezoneOffsetSeconds",
                type: "int32",
                internalType: "int32",
              },
            ],
          },
          {
            name: "interestRateSpec",
            type: "tuple",
            internalType: "struct ILoanRouterV2.InterestRateSpec",
            components: [
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "collateralTokenIds",
            type: "uint256[]",
            internalType: "uint256[]",
          },
          {
            name: "trancheSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.TrancheSpec[]",
            components: [
              {
                name: "lender",
                type: "address",
                internalType: "address",
              },
              {
                name: "amount",
                type: "uint256",
                internalType: "uint256",
              },
              { name: "rate", type: "uint256", internalType: "uint256" },
            ],
          },
          {
            name: "feeSpecs",
            type: "tuple[]",
            internalType: "struct ILoanRouterV2.FeeSpec[]",
            components: [
              {
                name: "kind",
                type: "uint8",
                internalType: "enum ILoanRouterV2.FeeKind",
              },
              {
                name: "recipient",
                type: "address",
                internalType: "address",
              },
              {
                name: "model",
                type: "address",
                internalType: "address",
              },
              { name: "options", type: "bytes", internalType: "bytes" },
            ],
          },
          {
            name: "approvalAddresses",
            type: "address[]",
            internalType: "address[]",
          },
          { name: "options", type: "bytes", internalType: "bytes" },
        ],
      },
      { name: "amount", type: "uint256", internalType: "uint256" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "reserves",
    inputs: [],
    outputs: [
      { name: "required", type: "uint256", internalType: "uint256" },
      { name: "excess", type: "uint256", internalType: "uint256" },
    ],
    stateMutability: "view",
  },
  {
    type: "function",
    name: "setReservesRequired",
    inputs: [{ name: "required", type: "uint256", internalType: "uint256" }],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "function",
    name: "withdraw",
    inputs: [
      { name: "recipient", type: "address", internalType: "address" },
      { name: "amount", type: "uint256", internalType: "uint256" },
    ],
    outputs: [],
    stateMutability: "nonpayable",
  },
  {
    type: "event",
    name: "Executed",
    inputs: [
      {
        name: "target",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "selector",
        type: "bytes4",
        indexed: true,
        internalType: "bytes4",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "RepaymentForwarded",
    inputs: [
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ReservesRequiredSet",
    inputs: [
      {
        name: "required",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  {
    type: "event",
    name: "ReservesWithdrawn",
    inputs: [
      {
        name: "recipient",
        type: "address",
        indexed: true,
        internalType: "address",
      },
      {
        name: "amount",
        type: "uint256",
        indexed: false,
        internalType: "uint256",
      },
    ],
    anonymous: false,
  },
  { type: "error", name: "InsufficientReserves", inputs: [] },
  { type: "error", name: "InvalidAddress", inputs: [] },
  { type: "error", name: "InvalidAmount", inputs: [] },
  { type: "error", name: "InvalidCurrencyToken", inputs: [] },
] as const;
